
import { checkProductsIsMarketingProduct, checkProductsIsConfectionService, checkProductIsNDEConfection } from '../utils/categoryUtils';

const CONFECTION_RESET_STORAGE_KEY = 'shouldResetConfection';
const FORM_RESET_STORAGE_KEY = 'shouldResetForm';

export function productSummary(products) {
  const val = {
    quantity: 0,
    quantityMrk: 0,
    quantityKonf: 0,
    quantityDelivery: 0,
    price: 0,
    summary: 0,
    summaryMrk: 0,
    summaryKonf: 0,
  };
  for (let i = 0; i <= products.length; i++) {
    /* eslint-disable radix */
    if (typeof products[i] !== 'undefined') {
      if (typeof products[i].quantity !== 'undefined') {
        if (products[i].id === 1000001 || checkProductsIsMarketingProduct(products[i])) {
          val.summaryMrk += products[i].price * parseInt(products[i].quantity);
          val.quantityMrk += parseInt(products[i].quantity);
        } else if (products[i].id !== 1000002 && (checkProductsIsConfectionService(products[i]) || checkProductIsNDEConfection(products[i]))) {
          val.summaryKonf += products[i].price * parseInt(products[i].quantity);
          val.quantityKonf += parseInt(products[i].quantity);
        } else if (products[i].id !== 1000002) {
          val.quantity += parseInt(products[i].quantity);
        }
        if (val.quantityDelivery === 0) val.quantityDelivery = 1;

        val.price += products[i].price;
        if (products[i].id !== 1000002) val.summary += (products[i].price * parseInt(products[i].quantity));
      }
    }
    /* eslint-enable radix */
  }
  return val;
}

export function setShouldResetConfection(value) {
  localStorage.setItem(CONFECTION_RESET_STORAGE_KEY, value);
}

export function getShouldResetConfection() {
  return localStorage.getItem(CONFECTION_RESET_STORAGE_KEY) === 'true';
}

export function setShouldResetForm(value) {
  localStorage.setItem(FORM_RESET_STORAGE_KEY, value);
}

export function getShouldResetForm() {
  return localStorage.getItem(FORM_RESET_STORAGE_KEY) === 'true';
}
